import { createPageSegmentLoadMetric } from '@confluence/browser-metrics/entry-points/metricConfigs';
import { HOME_OVERVIEW_FEED_SEGMENT_KEY } from '@confluence/browser-metrics/entry-points/metric-keys';

export const HOME_OVERVIEW_FEED_PAGE_SEGMENT = createPageSegmentLoadMetric({
	key: HOME_OVERVIEW_FEED_SEGMENT_KEY,
	// Set FMP = FCP if SSR (normally FMP = TTI)
	ssr: Boolean(window.__SSR_RENDERED__) ? { doneAsFmp: true } : undefined,
});
